module.exports = __webpack_public_path__ + "media/fonts/stroyka/stroyka-b63e2932073242750c1523e1b29f6c14.woff";